import { sameId } from "./helpers";

export function appendTestAttemptToHistory(userHistory, savedAttempt) {
  const history = Array.isArray(userHistory) ? userHistory : [];
  const { cursoId, bloque, tema, test, intentos } = savedAttempt || {};
  if (cursoId == null || !bloque || !tema || !test) {
    return history;
  }

  const next = history.map((course) => ({
    ...course,
    bloques: Array.isArray(course?.bloques)
      ? course.bloques.map((block) => ({
        ...block,
        temas: Array.isArray(block?.temas)
          ? block.temas.map((topic) => ({
            ...topic,
            historial: Array.isArray(topic?.historial) ? [...topic.historial] : [],
          }))
          : [],
      }))
      : [],
  }));

  let course = next.find((entry) => sameId(entry?.cursoId, cursoId));
  if (!course) {
    course = { cursoId, bloques: [] };
    next.push(course);
  }

  let block = course.bloques.find((entry) => String(entry?.nombreBloque) === String(bloque));
  if (!block) {
    block = { nombreBloque: bloque, temas: [] };
    course.bloques.push(block);
  }

  let topic = block.temas.find((entry) => String(entry?.nombreTema) === String(tema));
  if (!topic) {
    topic = { nombreTema: tema, intentos: 0, historial: [] };
    block.temas.push(topic);
  }

  const alreadySaved = test.idTest != null &&
    topic.historial.some((entry) => String(entry?.idTest) === String(test.idTest));
  if (!alreadySaved) {
    topic.historial.push(test);
  }
  topic.intentos = Number.isFinite(Number(intentos))
    ? Number(intentos)
    : topic.historial.length;

  return next;
}
